import { Injectable } from '@angular/core';
import {
  migrateStorefrontStorageKeys,
  STOREFRONT_GUEST_SESSION_KEY,
} from '../constants/storefront-storage.constants';

migrateStorefrontStorageKeys();

@Injectable({
  providedIn: 'root',
})
export class GuestSessionService {
  getSessionId(): string {
    if (typeof localStorage === 'undefined') {
      return this.newSessionId();
    }

    const existing = localStorage.getItem(STOREFRONT_GUEST_SESSION_KEY)?.trim();
    if (existing) {
      return existing;
    }

    const created = this.newSessionId();
    localStorage.setItem(STOREFRONT_GUEST_SESSION_KEY, created);
    return created;
  }

  private newSessionId(): string {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
    return `guest-${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
  }
}
